import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class BlogsService {

  constructor(private http: HttpClient) {}
  getTags() {
    return this.http.get<ApiResponseModel>('/api/tag');
  }
  getArticles() {
    return this.http.get<ApiResponseModel>('/api/article');
  }
  addTag(body) {
    return this.http.post<ApiResponseModel>('/api/tag', body);
  }
  addArticle(body) {
    return this.http.post<ApiResponseModel>('/api/article', body);
  }
  editArticle(body, articleID) {
    return this.http.patch<ApiResponseModel>('/api/article/' + articleID, body);
  }
  getArticleByID(articleID) {
    return this.http.get<ApiResponseModel>('/api/article/' + articleID);
  }
  deleteArticle(articleID) {
    return this.http.delete<ApiResponseModel>('/api/article/' + articleID);
  }
}
